import { colors } from 'design/src/tokens/colors';

const colorArray = [
  colors.green,
  // colors.blue,
  colors.cyan,
  colors.purple,
  colors.red,
  colors.orange,
  colors.yellow,
];

// const bgColors = colorArray.map((c) => c[50]);
// const foregroundColors = colorArray.map((c) => c[300]);
// const strokeColors = colorArray.map((c) => c[900]);

export function getUBarColor(index: number) {
  return colorArray[index % colorArray.length]!;
}
